import { render, staticRenderFns } from "./Sibiu.vue?vue&type=template&id=611d7304&"
import script from "./Sibiu.vue?vue&type=script&lang=js&"
export * from "./Sibiu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports